import React from 'react';
import cx from 'classnames';
import { Grid, Row, Col, Image } from 'react-bootstrap';
import Button from 'src/legacy/components/Button';
import styles from './styles.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';
import SlidePaneView from '../SlidePaneView';
import _ from 'lodash';

class DeactivateIntegrationView extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      show: false
    };

    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedSalesforceDescription = localizedStrings.components.integrations.salesforce.sliders.deactivate.description;
    this.localizedHubspotDescription = localizedStrings.components.integrations.hubspot.sliders.deactivate.description;

  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      show: nextProps.show   
    });
  }

  _handleDeleteClick() {
    if(this.props.type === "hubspot"){
      this.props.deactivateHubspotIntegration(this.props.id).then(() => {
        this.props.handleIntegrationsBackButton();
      })
    } else{
      this.props.deactivateIntegration(this.props.type).then(()=>{
        this.props.handleIntegrationsBackButton();
      });
      this.props.deactivateV2Integration(this.props.type).then(()=>{
        this.props.handleIntegrationsBackButton();
      });
    }
  }

  _handleCancelClick(){
    if(this.props.onCancel){
      this.props.onCancel();
    }
  }

  render() {
    const integrationType = _.get(this.props,"type");

    return (
      <SlidePaneView show={this.state.show} width="30vw">
        <div className={ styles.content }>
          <Row className={ styles.top }>
            <Col sm={12} className={styles.column}>
                <div className={styles.heading}>{ this.localizedIntegrations.actions.deactivating }</div>
                <div className={styles.label}>
                  {this.props.name}
                </div>

                  <p className={styles.description}>
                    {this.props.message}
                  </p>
                  
                {integrationType === "salesforce" && (<div>
                  <p className={styles.description}>{ localizedStrings.formatString(this.localizedSalesforceDescription.title,{ count : _.get(this.props,"accountsCount") }) }</p>
                  <p className={styles.salesforceDescription}>{ this.localizedSalesforceDescription.shared_field }</p>
                </div>)}  

                {integrationType === "hubspot" && (<div>
                  <p className={styles.description}>{ localizedStrings.formatString(this.localizedHubspotDescription.title,{ count : _.get(this.props,"accountsCount") }) }</p>
                  <p className={styles.hubspotDescription}>{  this.localizedHubspotDescription.shared_field }</p>
                </div>)}        

        
                <p className={styles.description}>
                   { this.localizedIntegrations.wish_to_continue }
                </p>
            </Col> 
          </Row>
          <Button.Tray className={styles.buttonTray}>
            <Button
              title={this.props.deactivating ? `${this.localizedIntegrations.actions.deactivating}...`: this.localizedCommons.actions.confirm}
              primary
              disabled={this.props.deactivating}
              className={styles.send}
              onClick={() => {this._handleDeleteClick()}}
              >
            </Button>
            <Button
              title={this.localizedCommons.actions.cancel}
              disabled={this.props.deactivating}
              className={styles.cancel}
              onClick={() => {this._handleCancelClick()}}
            >
            </Button>
          </Button.Tray>
        </div>
      </SlidePaneView>  
    );
  }
}

export default DeactivateIntegrationView;